const eventCollectionPageLimit = 6;
const $localStorageItem = 'eventCollectionConfig';
const $eventCollectionConfigTimeoutMinutes = 30;
const $eventCollectionForm = $('#eventCollections_filter_form');
const $eventCollectionNav = $eventCollectionForm.find('div.apifilter-body input[type=checkbox], div.apifilter-body select.form-control');
const $eventCollectionReset = $eventCollectionForm.find('#eventCollection_filter_reset');


class EventCollectionFilterClass {
    _defaults() {
        return {
            config: [],
            value: [],
            page: 0,
        };
    }

    init() {
        let data = this.load();

        $.each(data.value, (key, val) => {
            $(`#${val}`).prop('checked', true);
        });

        $.each(data.select, (key, val) => {
            $(`#${key}`).val(val);
        });

        $.each(data.config, (key, val) => {
            $(`[${eventCollectionFiltermenuDataAttribute}=${val}]`).next()
                .show();
        });

        this.apply();
    }

    load() {
        let data = JSON.parse(localStorage.getItem($localStorageItem)) || this._defaults();

        if (data.hasOwnProperty('timestamp')) {
            data.timestamp = new Date(data.timestamp);
        } else {
            data.timestamp = new Date();
        }

        if (!this.isValidTimestamp(data)) {
            localStorage.removeItem($localStorageItem);
            data = this._defaults();
        }

        return data;
    }

    isValidTimestamp(data) {
        if (!(data.timestamp instanceof Date)) {
            console.log('no date');
            return false;
        }

        const timeout = $eventCollectionConfigTimeoutMinutes * 60 * 1000;
        const timestamp = data.timestamp.getTime();
        const now = new Date().getTime();

        return (now - timestamp) < timeout;
    }

    save(data) {
        data.timestamp = new Date();
        localStorage.setItem($localStorageItem, JSON.stringify(data));
    }

    getValue(subset) {
        let data = this.load();
        return data[subset];
    }

    setValue(subset, val) {
        let data = this.load();
        data[subset] = val;
        this.save(data);
    }

    addValue(subset, val) {
        let data = this.load();

        if (!data[subset].includes(val)) {
            data[subset].push(val);
        }

        this.save(data);
        this.setValue('page', 0);
    }

    removeValue(subset, val) {
        let data = this.load();

        if (data[subset].includes(val)) {
            const index = data[subset].indexOf(val, 0);
            if (index > -1) {
                data[subset].splice(index, 1);
            }
        }

        this.save(data);
        this.setValue('page', 0);
    }

    apply() {
        let $list = $eventCollectionForm.find('.eventCollection__row');
        let data = this.load();

        // Loading animation
        $eventCollectionForm.find('.eventCollection--loading').show();
        $list.animate({opacity: 0.5}, 100);

        // Loading animation - disable
        setTimeout(function () {
            $eventCollectionForm.find('.eventCollection--loading').hide();
            $list.animate({opacity: 1}, 50);
        }, 250);


        $list.find('> div.eventCollection__item').addClass('visible');

        $.each(data.value, function (key, id) {
            let $i = $(`#${id}`);
            let value = $i.val();
            let target = $i.data('ec-target');

            if (value) {
                $list
                    .find(`:not([data-${target}-all=1]):not([data-${target}~=${value}])`)
                    .removeClass('visible');
            }
        });

        $.each(data.select, function (id, value) {
            if (id === 'ecFilter__date') {
                let $i = $(`#${id}`);
                let target = $i.data('ec-target');
                if (value) {
                    $list
                        .find(`:not([data-${target}~=${value}])`)
                        .removeClass('visible');
                }
            }

            if (['ecFilter__time', 'ecFilter__endtime'].includes(id)) {
                let $i = $(`#${id}`);
                let target = $i.data('ec-target');

                if (value) {
                    $list.find(`[data-${target}]`).each(function (k, item) {
                        let time = parseInt($(item).data(target));
                        if (
                            (id === 'ecFilter__time' && time < parseInt(value)) ||
                            (id === 'ecFilter__endtime' && time > parseInt(value))
                        ) {
                            $(this).removeClass('visible');
                        }
                    });
                }
            }
        });

        this.paginate(data.page);
    }

    paginate(currentPage) {
        this.setValue('page', currentPage);

        let $list = $eventCollectionForm.find('.eventCollection__row');
        let $items = $list.find('> div.eventCollection__item.visible');
        let amount = $items.length;
        let pages = Math.ceil(amount / eventCollectionPageLimit);
        let begin = currentPage * eventCollectionPageLimit;
        let end = begin + eventCollectionPageLimit;
        let $paginationIndicator = $('.eventCollection_pagination--indicator');
        let $notFoundWarning = $eventCollectionForm.find('.eventCollection__notFound');

        $paginationIndicator.find('span.begin').text(parseInt(begin) + 1);
        $paginationIndicator.find('span.end').text(amount < end ? amount : end);

        $list.find('.f3-widget-paginator').remove();

        $notFoundWarning.hide();
        if (!amount) {
            $notFoundWarning.show();
        }

        if (pages < 2) {
            return;
        }

        $list.append('<ul class="f3-widget-paginator"></ul>');
        let $paginator = $list.find('.f3-widget-paginator');

        /** create pages */
        for (let i = 0; i < pages; i++) {
            if (i === parseInt(currentPage)) {
                $paginator.append(`<li data-page="${i}" class="current"><span>${i + 1}</span></li>`);
            } else {
                $paginator.append(`<li data-page="${i}"><a href="javascript:eval();">${i + 1}</a></li>`);
            }
        }

        /** process items */
        for (let i = 0; i < amount; i++) {
            if (i < begin || i >= end) {
                $($items[i]).hide();
            } else {
                $($items[i]).show();
            }
        }

        $paginator.find('a').click((e) => {
            this.paginate($(e.currentTarget).parent().data('page'));

            // $('html, body').animate({
            //     scrollTop: $("#eventCollections_filter_form").offset().top
            // }, 400);
        });
    }

    reset() {
        $eventCollectionForm[0].reset();

        let data = this.load();
        data.value = [];
        data.select = {};
        this.save(data);

        eventCollection.apply();
    }
}


/**
 * checkbox management
 */
$eventCollectionNav.change(function () {
    /* localStorage */
    let id = $(this).attr('id');

    if ($(this).is('input[type=checkbox]')) {

        if ($(this).is(':checked')) {
            eventCollection.addValue('value', id);
        } else {
            eventCollection.removeValue('value', id);
        }
    }

    if ($(this).is('select')) {
        let selects = eventCollection.getValue('select') || {};
        selects[id] = $(this).val();
        eventCollection.setValue('select', selects);
    }

    eventCollection.apply();
});


/**
 * Reset
 */
$eventCollectionReset.click(function () {
    eventCollection.reset();
});


/**
 * INIT
 */
let eventCollection = new EventCollectionFilterClass();
eventCollection.init();


